import type { ApiApplicationDetails } from 'types/Application'
import { Item } from '../DetailsList'
import { useTranslation } from 'react-i18next'
import { DetailsRow } from './details-row'
import { Box, Typography } from '@mui/material'

export const ApplicationData = ({ data }: { data: ApiApplicationDetails }): JSX.Element => {
  const { t } = useTranslation()

  return (
    <DetailsRow
      title={t('application.fullUserApplicationData')}
      description="Complete consumer data of promotion participants"
    >
      {[
        <Item key={`application.fullName`} label={t('application.fullName')} text={data.application_fullName} />,
        data.application_email ? (
          <Item key={`application.email`} label={t('application.email').toLowerCase()} text={data.application_email} />
        ) : null,
        data.application_barcode ? (
          <Item key={`application.barcode`} label={t('application.barcode')} text={data.application_barcode} />
        ) : null,
        data.application_barcode2 ? (
          <Item key={`application.barcode`} label={t('application.barcode2')} text={data.application_barcode2} />
        ) : null,
        data.application_phoneNumber ? (
          <Item key={`application.phone`} label={t('application.phone')} text={data.application_phoneNumber} />
        ) : null,
        data.application_dropdown ? (
          <Item key={`application.dropdown`} label={t('application.dropdown')} text={data.application_dropdown} />
        ) : null,
        data.application_streetName ? (
          <Item key={`application.streetName`} label={t('application.streetName')} text={data.application_streetName} />
        ) : null,
        data.application_streetName ? (
          <Item key={`application.streetName`} label={t('application.streetName')} text={data.application_streetName} />
        ) : null,
        data.application_buildingName ? (
          <Item
            key={`application.buildingName`}
            label={t('application.buildingName')}
            text={data.application_buildingName}
          />
        ) : null,
        data.application_buildingNumber || data.application_apartmentNumber ? (
          <Item
            key={`application.buildingNumber-application_apartmentNumber`}
            label={`${t('application.buildingNumber')}${data.application_apartmentNumber !== undefined ? '/' + t('application.apartmentNumber') : ''}`}
            text={`${data.application_buildingNumber ?? ''}${data.application_apartmentNumber !== undefined ? '/' + data.application_apartmentNumber : ''}`}
          />
        ) : null,
        data.application_country ? (
          <Item key={`application.country`} label={t('application.country')} text={data.application_country} />
        ) : null,
        data.application_city ? (
          <Item key={`application.city`} label={t('application.city')} text={data.application_city} />
        ) : null,
        data.application_postalCode ? (
          <Item key={`application.postalCode`} label={t('application.postalCode')} text={data.application_postalCode} />
        ) : null,
        data.application_comments ? (
          <Item
            key={`application.additionalInfo`}
            label={t('application.additionalInfo')}
            text={data.application_comments}
          />
        ) : null,
        data.application_closedQuestion ? (
          <Item
            key={`application.closedQuestion`}
            label={t('application.closedQuestion')}
            text={data.application_closedQuestion}
          />
        ) : null,
        data.application_closedQuestion2 ? (
          <Item
            key={`application.closedQuestion2`}
            label={t('application.closedQuestion2')}
            text={data.application_closedQuestion2}
          />
        ) : null,
        data.application_openQuestion ? (
          <Item
            key={`application.openQuestion`}
            label={t('application.openQuestion')}
            text={data.application_openQuestion}
          />
        ) : null,
        data.application_openQuestion2 ? (
          <Item
            key={`application.openQuestion2`}
            label={t('application.openQuestion2')}
            text={data.application_openQuestion2}
          />
        ) : null,
        data.application_invoiceNumber ? (
          <Item
            key={`application.invoiceNumber`}
            label={t('application.invoiceNumber')}
            text={data.application_invoiceNumber}
          />
        ) : null,
        data.application_prizeSelection ? (
          <Item
            key={`application.prizeSelection`}
            label={t('application.prizeSelection')}
            text={data.application_prizeSelection}
          />
        ) : null,
        data.application_notes ? (
          <Item key={`application.notes`} label={t('application.notes')} text={data.application_notes} />
        ) : null,
        <Item
          key={`application.market`}
          label={t('application.market')}
          text={
            <Box>
              {data.market_name}

              {!!data.market_description && (
                <Typography display="block" color="grey.400" variant="body2" lineHeight={1} fontWeight={400}>
                  ({data.market_description})
                </Typography>
              )}
            </Box>
          }
        />,
        <Item key={`application.language`} label={t('application.language')} text={data.marketLanguage_name} />,
      ].filter(el => el !== null)}
    </DetailsRow>
  )
}
